import i18n from 'modules/core/lib/i18n'

export type DurationUnit = 'hours' | 'days' | 'weeks' | 'months'

export const DEFAULT_DURATION_UNIT: DurationUnit = 'days'

export const isValidDateUnit = (unit: string): unit is 'hours' | 'days' | 'weeks' | 'months' =>
  ['hours', 'days', 'weeks', 'months'].includes(unit)

export const getDurationUnitOptions = () => [
  { label: i18n.t('workflows.node_type.task.duration_units.hours'), value: 'hours' },
  { label: i18n.t('workflows.node_type.task.duration_units.days'), value: 'days' },
  { label: i18n.t('workflows.node_type.task.duration_units.weeks'), value: 'weeks' },
  { label: i18n.t('workflows.node_type.task.duration_units.months'), value: 'months' },
]
